<template>
    <div class="popup cart__popup" :id="id">
        <i data-element="close_cart_modal_confirm"
           class="popup__close arcticmodal-close" @click="cancel()"></i>
        <div class="cart__popup-title" v-if="title">{{ title }}</div>
        <div class="cart__popup-text" v-html="body"></div>
        <div class="cart__popup-buttons">
            <button data-element="ok_cart_modal_confirm"
                    class="button" @click="confirm()">{{ okTitle }}</button>
            <button data-element="cancel_cart_modal_confirm"
                    class="button button--outline" @click="cancel()">{{ cancelTitle }}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalConfirmCart',
    props: {
        id: {
            type: String,
            require: true,
        },
        title: {
            type: String,
        },
        body: {
            type: String,
        },
        okTitle: {
            type: String,
        },
        cancelTitle: {
            type: String,
        },
        confirmFunction: {
            type: Function,
        },
        cancelFunction: {
            type: Function,
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        confirm() {
            const t = this;
            var resConfirmFunction;
            if (typeof t.confirmFunction === 'function') {
                resConfirmFunction = t.confirmFunction();
            }
            if (resConfirmFunction !== false) {
                t.close();
            }
        },
        cancel() {
            const t = this;
            var resCancelFunction;
            if (typeof t.cancelFunction === 'function') {
                resCancelFunction = t.cancelFunction();
            }
            if (resCancelFunction !== false) {
                t.close();
            }
        }
    }
}
</script>